type CurrencyOptions = {
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const formatDateShort = (value?: string | number | Date | null, fallback = "—") => {
  if (!value) {
    return fallback;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return fallback;
  }

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatLocalDateTime = (value: string | number | Date, fallback = "—") => {
  // Lighthouse's DateTime scalar emits "YYYY-MM-DD HH:MM:SS" without a timezone suffix.
  // The server is always UTC, so we append Z when no offset is present so the browser
  // treats it as UTC and converts correctly to local time.
  const normalized =
    typeof value === "string" && !/Z|[+-]\d{2}:?\d{2}$/.test(value) ? `${value.replace(" ", "T")}Z` : value;
  const date = normalized instanceof Date ? normalized : new Date(normalized);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat("en-US", { dateStyle: "short", timeStyle: "short" }).format(date);
};

export const formatCurrencyFromMicro = (micro: number, options: CurrencyOptions = {}) => {
  const { currency = "USD", minimumFractionDigits = 2, maximumFractionDigits = 2 } = options;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(micro / 1_000_000);
};

export const formatCurrencyFromMinorUnits = (amount?: number | null, currency = "USD", fallback = "—") => {
  if (amount === null || amount === undefined) {
    return fallback;
  }

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  });
  const fractionDigits = formatter.resolvedOptions().maximumFractionDigits ?? 2;
  return formatter.format(amount / 10 ** fractionDigits);
};
